import React, { createContext, useContext } from 'react';

type SelectionContextType = {
  active: boolean;
};

const SelectionContext = createContext<SelectionContextType | undefined>(undefined);

export const SelectionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // This provider simply marks that we're in selection flow
  const value: SelectionContextType = { active: true };
  return (
    <SelectionContext.Provider value={value}>
      {children}
    </SelectionContext.Provider>
  );
};

export const useSelection = (): SelectionContextType | undefined => {
  return useContext(SelectionContext);
};
